export const ar = {
  //home page

  LoadMoreProduct: 'المزيد من المنتجات',
  btn2: 'المزيد من التعليقات',
  btn4: 'مزيد من المعلومات حولنا',
  Result: 'حلول برمجية ',
  Digital: 'مصمَّمة لنموّك',
  Solution: 'ذكية ',
  provide:
    'نحوّل احتياجات عملك إلى برمجيات موثوقة: منتجات مخصصة ومنصات ويب وتطبيقات جوال، بفريق ذي خبرة.',
  ourServices: 'خدماتنا',
  TopProducts: 'أفضل المنتجات ',
  CustomerFeedback: 'آراء العملاء',
  textAboutUs:
    'بدأت شركة نوا، المسجلة برقم 16154778، أعمالها في عام 2018. بدأ مؤسسو هذه الشركة، الذين يمتلكون خبرة تزيد عن عشر سنوات في مجال البرمجة وبيئة الشركات الناشئة في البلاد، بتأسيس أعمالهم، مستخدمين خبراتهم وتجارب الآخرين.',
  textAboutUsIP:
    'بدأت شركة نوا، المسجلة برقم 16154778، أعمالها في عام 2018. بدأ مؤسسو هذه الشركة، الذين يمتلكون خبرة تزيد عن عشر سنوات في مجال البرمجة وبيئة الشركات الناشئة في البلاد، بتأسيس أعمالهم، مستخدمين خبراتهم وتجارب الآخرين.',
  OurProcess: 'عمليتنا',
  OurTrustedPartner: 'شريكنا الموثوق',
  Explore: 'اكتشف أفكار عملك من خلال استراتيجياتنا الحديثة',
  team: 'فريقنا مستعد لمساعدتك في تحقيق أهداف عملك من خلال استراتيجيات التسويق الرقمي الإبداعية والحديثة.',
  text1: 'شهادة',
  blog: 'المدونات',
  labelName: 'الاسم الأول',
  labelLastName: 'الاسم الثانی',
  labelEmail: 'بريد إلكتروني',
  labelNumber: 'رقمک',
  //header,
  Home: 'البیت',
  Products: 'المنتجات',
  Projects: 'المشاريع',
  Blogs: 'المدونات',
  AboutUs: 'معلومات عنا',
  ContactUs: 'اتصل بنا',
  ChangeLang: 'تغيير اللغة إلى',
  SwitchMode: 'تغيير الخلفية إلى',
  mode1: 'الوضع الداكن',
  mode2: 'الوضع الفاتح',
  footerText:
    'شركة نوا، المسجلة برقم 16154778، هي شركة تقنية رائدة، متخصصة في تطوير برمجيات الويب والهواتف المحمولة. نركز على تصميم وبناء تطبيقات عالية الجودة لنظامي iOS وAndroid، بالإضافة إلى مواقع إلكترونية متطورة مصممة لتلبية متطلبات المشهد الرقمي سريع التطور اليوم.',
  footerTextIp:
    'شركة نوا، المسجلة برقم 16154778، هي شركة تقنية رائدة، متخصصة في تطوير برمجيات الويب والهواتف المحمولة. نركز على تصميم وبناء تطبيقات عالية الجودة لنظامي iOS وAndroid، بالإضافة إلى مواقع إلكترونية متطورة مصممة لتلبية متطلبات المشهد الرقمي سريع التطور اليوم.',
  QuickLinks: 'روابط سريعة',
  Support: 'الدعم',
  Certification: 'الشهادات',
  allJob: 'الفرص الوظيفية',
  Address: 'العنوان',
  // about us
  aboutText1: 'شركة نوا',
  aboutText2:
    'نحن في شركة  نوا نؤمن بقوة التسويق الرقمي ونساعدك في رفع علامتك التجارية باستخدام الاستراتيجيات الحديثة. منذ تأسيسنا في عام 2019، كان هدفنا هو تقديم حلول مبتكرة وفعالة في العالم الرقمي. مع فريق من الخبراء وتجارب ناجحة في مختلف المجالات، نحن هنا لمساعدتك على البروز عبر الإنترنت.',
  aboutText3: 'مهمتنا',
  aboutblog:
    'مهمتنا هي تعزيز العلامات التجارية والأعمال من خلال استراتيجيات حديثة وإبداعية.نحن نساعدك على تحقيق أهداف عملك باستخدام التكنولوجيا والابتكار الرقمي',
  aboutText5: 'رؤية الشركة ',
  aboutText6:
    'تركز خطط الشركة حاليً ا على تطوير المنتجات الخارجية(التطبيقات والمواقع الإلكترونية) والتركيز على مجالات الذكاء الاصطناعي وتنفيذ مشاريع الأتمتة الداخلية.',
  aboutText7: 'الجوائز والتكريمات',
  aboutText8: ' مرشح نهائي لأفضل تطبيق في مهرجان التطبيقات والجوال في إيران عام 2017',
  aboutText9: 'مرشح نهائي لأفضل مشروع في مهرجان استان أب عام 2021',
  ReadMore: 'اقرأ المزيد',
  // job
  JobOpportunities: 'فرص العمل',
  JobDescription: 'المسمى الوظيفي',
  closed: 'مغلق',
  palaseHolderName: 'أدخل اسمك الأول',
  palaseHolderFamily: 'أدخل اسمك الأخير',
  palaseHolderEmail: 'أدخل بريدك الإلكتروني',
  palaseHolderPhone: 'أدخل رقم هاتفك',
  RelatedPost: 'المشاركات ذات الصلة',
  LoadMoreJobs: 'تحميل المزيد من الوظائف',
  // محصولات
  ViewProduct: 'عرض المنتج',
  ViewProject: 'عرض المشروع',
  TechnicalDetails: 'التفاصيل الفنية',
  gallery: 'معرض الصور',
  TopFeatures: 'أفضل الميزات',
  OtherFeatures: 'ميزات أخرى',
  Purpose: 'الغرض من المنتج',
  // contact us
  Message: 'رسالتك',
  Message2: 'أدخل رسالتك',
  email: 'التواصل عبر البريد الإلكتروني',
  phone: 'التواصل عبر الهاتف',
  whatsapp:"تواصل عبر واتساب",
  phoneRequired: 'الرجاء إدخال رقم هاتفك',
  fileTypeInvalid: 'يُسمح فقط بملفات PDF وPNG وJPG.',
  fileTooLarge: 'يجب ألا يتجاوز حجم الملف 30 ميغابايت.',
  allowedFiles: 'الصيغ المسموحة: PDF، PNG، JPG',
  Max: 'الحد الأقصى لحجم الملف 30 ميغابايت!',
  seoDescription: 'تصمّم نوفا وتبني منتجات برمجية ومنصات ويب وتطبيقات جوال للشركات النامية.',
  fileRequired: 'يرجى إرفاق سيرتك الذاتية',
  textRequired: 'تم إدخال النص',
  phoneInvalid: 'رقم الهاتف المدخل غير صالح',
  emailRequired: 'الرجاء إدخال عنوان بريدك الإلكتروني',
  emailInvalid: 'تنسيق البريد الإلكتروني غير صحيح',
  nameRequired: 'الرجاء إدخال اسمك الأول',
  lastNameRequired: 'الرجاء إدخال اسم العائلة',
  SuccessMessage: 'شكراً لك! استلمنا بياناتك وسنتواصل معك قريباً.',
  errorMessage: 'حدث خطأ ما. يرجى التحقق من بياناتك والمحاولة مرة أخرى.',
  errorServerMessage: 'الخادم يواجه مشكلة حالياً. يرجى المحاولة بعد دقائق.',
  Loading: 'جارٍ التحميل…',
  //irangardi
  downloadApplication: 'تنزيل التطبيق ',
  DownloadResome: 'محفظة أعمالنا',
  visitWebsite: 'زيارة الموقع الإلكتروني',
  loadMoreBlog: 'تحميل المزيدالمدونة',
  send: 'إرسال',
  sending: 'جارٍ الإرسال…',
  download:'تنزيل',
  androidVersion: "إصدار أندرويد",
  iosVersion: "إصدار iOS",
  CV: 'السيرة الذاتية',
  Upload: 'رفع ملف',
  networkError: 'لا يوجد اتصال. تحقق من الإنترنت وحاول مرة أخرى.',
  textInvalid: 'رسالتك تحتوي على رموز غير صالحة',
  remote: 'عن بُعد',
  view: 'عرض',
  noItems: 'لا يوجد ما يُعرض هنا حالياً. يرجى العودة قريباً.',
  backToJobs: 'جميع الوظائف',
  aboutRole: 'نبذة عن الوظيفة',
  applyNow: 'قدّم على هذه الوظيفة',
  applyHint: 'أرسل لنا بياناتك وسيرتك الذاتية. نرد على جميع الطلبات.',
  seoProducts: 'منتجات ومنصات برمجية من نوفا: تطبيقات ويب وجوال وسطح مكتب للشركات النامية.',
  seoProjects: 'مشاريع مختارة نفذتها نوفا: مواقع وتطبيقات جوال وبرمجيات مخصصة لشركات حقيقية.',
  seoBlog: 'مقالات فريق نوفا حول تطوير الويب وتطبيقات الجوال وتصميم الواجهات وتحسين محركات البحث والذكاء الاصطناعي والأمن.',
  seoAbout: 'تعرّف على نوفا ورسالتها ورؤيتها والفريق الذي يبني منتجات برمجية للشركات.',
  seoContact: 'تواصل مع نوفا لمناقشة مشروع موقعك أو تطبيقك أو برمجياتك المخصصة.',
  seoJobs: 'الوظائف المتاحة في نوفا. انضم إلى فريق عن بُعد يبني منتجات برمجية.',
  seoCertification: 'الشهادات والجوائز التي حصلت عليها نوفا.',
  seoFeedback: 'آراء عملائنا حول العمل مع نوفا.',
};
